// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/TrackingKindSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/TrackingKindSearchBy.proto.
 */
export const file_Enumerations_TrackingKindSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CidFbnVtZXJhdGlvbnMvVHJhY2tpbmdLaW5kU2VhcmNoQnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKm8KFFRyYWNraW5nS2luZFNlYXJjaEJ5Ei0KIVRSQUNLSU5HX0tJTkRfU0VBUkNIX0JZX1RFTkFOVF9JRBAAGgbKx80PAQMSKAocVFJBQ0tJTkdfS0lORF9TRUFSQ0hfQllfTkFNRRABGgbKx80PAQRCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a tracking kind (billable, etc.) can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.TrackingKindSearchBy
 */
export enum TrackingKindSearchBy {
  /**
   * Search through the tenant id of a tracking kind.
   *
   * @generated from enum value: TRACKING_KIND_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the name of a tracking kind.
   *
   * @generated from enum value: TRACKING_KIND_SEARCH_BY_NAME = 1;
   */
  NAME = 1,
}

/**
 * Describes the enum time_tracking.enumerations.TrackingKindSearchBy.
 */
export const TrackingKindSearchBySchema: GenEnum<TrackingKindSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_TrackingKindSearchBy, 0);

